module.exports = __webpack_public_path__ + "img/blockS2-card3.11a64f2f.svg";